import React from 'react'
import Pagination from '../../Hocs/Pagination'

import Insights from './insights'
import MarketShare from './marketShare'

export default Pagination({
  numberOfSlides: (props) => {
    if (props.data.length > 6) {
      return 3
    }
    return 2
  },

  renderItem: (props, index) => {
    const { length } = props.data
    let maxPerPage = 6
    if (length > 6 && length <= 8) {
      maxPerPage = 4
    }

    const hasMultipleInsightsPages = length > 6

    const items1 = props.data.slice(0, maxPerPage)
    const items2 = props.data.slice(maxPerPage)

    const indexOffset = hasMultipleInsightsPages ? 1 : 0

    if (index === 0) {
      return <Insights {...props} active={props.currentPage === 0} data={items1} currentScreen={props.currentScreen[0]} page={0} />
    } else if (hasMultipleInsightsPages && index === 1) {
      return <Insights {...props} active={props.currentPage === 1} data={items2} currentScreen={props.currentScreen[1]} page={1} />
    } else if (index - indexOffset === 1) {
      return <MarketShare {...props} active={props.currentPage - indexOffset === 1} />
    }
  }
})
